<template>
  <div v-if="showCtaLabel">
    <div v-if="buynowData.Display.Mode === 'Simple'" class="_rfp_mctb_mc_02_">
      <rfp-mctb-simple-single-retailer
        :productname="buynowData.Product.Title"
        :productids="buynowData.Product.ProductId"
        :datalayers="buynowData.Product.BuyOnlineSimpleModeTags"
        :datalayers-g-s="buynowData.Product.BuyOnlineSimpleModeTagsGS"
        :store-locator-mode-options="buynowData.Product.Retailers[0]"
        :buy-now-text="buyNow"
      ></rfp-mctb-simple-single-retailer>
    </div>

    <div v-else-if="buynowData.Display.Mode === 'Direct'" class="_rfp_mctb_mc_04_">
      <rfp-mctb-simple-mode
        :view-type="buynowData.Display.View"
        :retailer-details="buynowData"
        :header-text="carouselHeader"
        :enable-rtl="enableRtl"
        :retailer-unavailable="retailerUnavailable"
        :component-diffs="componentDiffs"
        :productname="buynowData.Product.Title"
        :productids="buynowData.Product.ProductId"
      >
      </rfp-mctb-simple-mode>
    </div>
    <div v-else-if="buynowData.Display.Mode === 'Popup-optional'" class="_rfp_mctb_mc_05_">
      <rfp-mctb-pop-up-action-mode
        :enable-buynow-retailers="enableBuynowRetailers"
        :retailer-unavailable="retailerUnavailable"
        :header-text="carouselHeader"
        :component-diff="componentDiffs"
        close-icon-text="Close window"
        :initial-data="buynowData"
        :productname="buynowData.Product.Title"
        :productids="buynowData.Product.ProductId"
        :initial-extra-params="extraParams"
      >
      </rfp-mctb-pop-up-action-mode>
    </div>
    <div v-else-if="buynowData.Display.Mode === 'Popup'" class="_rfp_mctb_mc_05_">
      <rfp-mctb-pop-up-mode
        :view-type="buynowData.Display.View"
        :enable-buynow-retailers="enableBuynowRetailers"
        :retailer-unavailable="retailerUnavailable"
        :enable-rtl="enableRtl"
        :buy-now-text="buyNow"
        :carousel-header-text="carouselHeader"
        :store-locator-mode-options="buynowData"
        :component-diffs="componentDiffs"
        :productname="buynowData.Product.Title"
        :productids="buynowData.Product.ProductId"
      >
      </rfp-mctb-pop-up-mode>
    </div>
    <div
      v-if="buynowData.Product.BuyOffline?.IsActive && buynowData.Product.BuyOffline?.OfflineUrl"
    >
      <rfp-mctb-store-locator-mode
        :buy-offline="buynowData.Product.BuyOffline"
        :offline-button-text="buyOfflineButtonText"
        :productname="buynowData.Product.Title"
        :productids="buynowData.Product.ProductId"
      >
      </rfp-mctb-store-locator-mode>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';
import RfpMctbSimpleSingleRetailer from './rfp-mctb-simple-single-retailer/rfp-mctb-simple-single-retailer.vue';
import RfpMctbPopUpMode from './rfp-mctb-pop-up-mode/rfp-mctb-pop-up-mode.vue';
import RfpMctbPopUpActionMode from './rfp-mctb-pop-up-action-mode/rfp-mctb-pop-up-action-mode.vue';
import RfpMctbSimpleMode from './rfp-mctb-simple-mode/rfp-mctb-simple-mode.vue';
import RfpMctbStoreLocatorMode from './rfp-mctb-store-locator-mode/rfp-mctb-store-locator-mode.vue';

const Events = {
  PopupDirection: 'rfp-mctb-enable-popup-direction',
};

export default {
  name: 'rfp-mctb-main-container',
  components: {
    RfpMctbSimpleSingleRetailer,
    RfpMctbPopUpMode,
    RfpMctbPopUpActionMode,
    RfpMctbSimpleMode,
    RfpMctbStoreLocatorMode,
  },
  props: {
    buynowData: {
      type: Object,
      required: true,
    },
    buyOnlineButtonText: {
      type: String,
      default: 'Online',
    },
    buyOfflineButtonText: {
      type: String,
      default: 'Offline',
    },
    carouselHeader: {
      type: String,
      default: 'Carousel Header',
    },
    buyNow: {
      type: String,
      default: 'Buy Now',
    },
    enableRtl: {
      type: Boolean,
      required: true,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    enableBuynowRetailers: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    sportLiteMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const params = new URLSearchParams(window.location.search.toLowerCase());
    const action = this.buynowData.Action;
    return {
      extraParams: {},
      showCtaLabel: true,
      delayDisplayTime: action.DelayTimer * 1000,
      QuerystringParamValue: action.QuerystringParamValue.toLowerCase(),
      urlParams: params.get(action.QuerystringParamName.toLowerCase()),
      urlParamsRetailer: params.get(
        this.buynowData.ScanToBuyRedirect.ScanToBuyQuerystringName.toLowerCase(),
      ),
    };
  },
  mounted() {
    const action = this.buynowData.Action;

    if (this.buynowData.Action && !this.buynowData.ScanToBuyRedirect.EnableScanToBuyRedirect) {
      if (action.Name === 'Hide CTA' && this.urlParams === this.QuerystringParamValue) {
        this.showCtaLabel = false;
      }

      if (action.Name === 'Delay Display' && this.urlParams === this.QuerystringParamValue) {
        this.showCtaLabel = false;
        this.hideShowCta();
      }

      if (
        action.Name === 'Display Retailer' &&
        this.buynowData.Display.Mode === 'Popup' &&
        !this.sportLiteMode &&
        this.urlParams === this.QuerystringParamValue
      ) {
        this.autoPopupEvent();
      }
    }
    eventBus.emit('default-variant');
    eventBus.on('rfp-mctb-scan-to-buy-redirect', (val) => {
      if (!val) {
        if (this.buynowData.Product.Retailers.find(this.findRetailerData) && !this.sportLiteMode) {
          this.redirectRetailers(this.buynowData.Product.Retailers.find(this.findRetailerData));
        } else {
          eventBus.emit(Events.PopupDirection);
        }
      }
    });
    eventBus.on('rfpTaggingFoundation', (values) => {
      if (!window.wsf) {
        window.wsf = { refappMoreinformation: {} };
      }
      delete window.wsf.refappMoreinformation;
      window.wsf.refappMoreinformation = values;
    });

    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
  },
  methods: {
    autoPopupEvent() {
      if (this.urlParams === this.QuerystringParamValue) {
        eventBus.emit('rfp-auto-popup-open-buynow-true');
      }
    },
    hideShowCta() {
      this.hideShowCtaAction();
    },
    hideShowCtaAction() {
      if (this.buynowData.Action.Name != 'Hide CTA') {
        this.showCtaLabel = true;
      }
    },
    findRetailerData(findRetailers) {
      return findRetailers.Name === this.$cookies.get('ERetailerName');
    },
    redirectRetailers(retailerInfo) {
      if (
        this.buynowData.ScanToBuyRedirect.EnableScanToBuyRedirect &&
        this.urlParamsRetailer ===
          this.buynowData.ScanToBuyRedirect.ScanToBuyQuerystringValue.toLowerCase()
      ) {
        if (window.dataLayer) {
          let tags = {};
          try {
            tags = JSON.parse(this.buynowData.Product.BuyOnlineSimpleModeTags);
          } catch (e) {
            console.log(
              'error/rfp-mctb-main-container#redirectRetailers: Standard (GA) tag parsing failed',
              e,
            );
          }

          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.buynowData.Product.Title,
              productId: retailerInfo.ProductItemId,
              retailerName: retailerInfo.Name,
            },
          });
        }
        const target = retailerInfo.OpenInNewWindow === true ? '_blank' : '_self';
        return window.open(retailerInfo.RetailerUrl, target);
      }

      eventBus.emit(Events.PopupDirection);
    },
  },
};
</script>
